import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default props => (
  <SvgIcon {...props} viewBox="0 0 330 300">
    <g>
      <path
        d="M288.04,77.36h-246c-16.29,0-29.5-13.21-29.5-29.5v0c0-16.29,13.21-29.5,29.5-29.5h246
		c16.29,0,29.5,13.21,29.5,29.5v0C317.54,64.16,304.33,77.36,288.04,77.36z"
      />
      <path
        d="M248.87,146.1H79.9c-16.24,0-29.4-13.16-29.4-29.4v0c0-16.24,13.16-29.4,29.4-29.4h168.97
		c16.24,0,29.4,13.16,29.4,29.4v0C278.27,132.94,265.11,146.1,248.87,146.1z"
      />
    </g>
    <path
      d="M210.78,214.95H119.3c-16.31,0-29.53-13.22-29.53-29.53v0c0-16.31,13.22-29.53,29.53-29.53h91.48
	c16.31,0,29.53,13.22,29.53,29.53v0C240.31,201.73,227.09,214.95,210.78,214.95z"
    />
    <path
      d="M172.66,280.68h-16.53c-15.68,0-28.38-12.71-28.38-28.38v0c0-15.68,12.71-28.38,28.38-28.38h16.53
	c15.68,0,28.38,12.71,28.38,28.38v0C201.04,267.97,188.33,280.68,172.66,280.68z"
    />
  </SvgIcon>
)
